<template>
  <mdb-container>
    <mdb-navbar color="teal" class="fixed-top navbar-expand-lg navbar-light white scrolling-navbar" hamburger navIconClass="dark-teal-text" expand="xl">
      <mdb-navbar-brand>
                     <a class="navbar-brand waves-effect" href="/" >
                    <strong class="blue-text">PERSONAL SIGNER</strong>
                </a>
      </mdb-navbar-brand>
      <mdb-navbar-toggler>
        <mdb-navbar-nav right>
          <mdb-nav-item href="/" waves-fixed>Home</mdb-nav-item>
          <mdb-nav-item href="/#/Solutions" waves-fixed>Solutions</mdb-nav-item>
          <mdb-nav-item href="/#/psmacs" waves-fixed>PersonalSigner for Mac</mdb-nav-item>
          <mdb-nav-item href="/#/Help" waves-fixed>Help</mdb-nav-item>
        </mdb-navbar-nav>
      </mdb-navbar-toggler>
    </mdb-navbar>
  </mdb-container>
</template>


<script>
  import { mdbNavbar, mdbNavItem, mdbNavbarNav, mdbNavbarToggler, mdbContainer} from 'mdbvue';
  export default {
    name: 'HamburgerMenuPage', 
    components: {
      mdbNavbar,
      mdbNavItem,
      mdbNavbarNav,
      mdbNavbarToggler,
      mdbContainer
    }
  }
</script>